module.exports = "/_next/static/images/img-super-benefit-1-506714be5a4e69bfd5c10b28d152304c.svg";